var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.07,40.41s-12.4,2-13,12.41S58,132.47,58,132.47s3.26,12.4,17,12.4H94.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.83,40.41s12.41,2,13.06,12.41S120,132.47,120,132.47s-3.27,12.4-17,12.4H83.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.63,145.53s-3.25,52.14,35.91,52.88c34.61.65,49.62-14.36,49.62-79.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 59.91,
    cy: 38.13,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 117.36,
    cy: 38.13,
    r: 7.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 174.16,
    cy: 96.23,
    r: 19.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 174.16,
    cy: 96.23,
    r: 8.16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/STETHOSCOPE.5a414879971141b572d3b6aa9e943bcd.svg";
export { ForwardRef as ReactComponent };